import { Component } from '@theme/component';

/**
 * Product Card Add to Cart Component
 * Ensures proper form handling without page redirect
 */
export class ProductCardAtcComponent extends Component {
  connectedCallback() {
    super.connectedCallback();
    
    const form = this.querySelector('form');
    if (form) {
      // Ensure form doesn't submit normally
      form.addEventListener('submit', this.handleFormSubmit);
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    
    const form = this.querySelector('form');
    if (form) {
      form.removeEventListener('submit', this.handleFormSubmit);
    }
  }

  /**
   * Handle form submission
   * This ensures ProductFormComponent's handleSubmit is called
   * @param {Event} event
   */
  handleFormSubmit = (event) => {
    // The ProductFormComponent will handle the actual submission
    // We just need to make sure the default action doesn't happen
    const productFormComponent = event.target.closest('product-form-component');
    if (productFormComponent) {
      // Let the ProductFormComponent handle it
      // It will call preventDefault internally
      return;
    }
  };
}

if (!customElements.get('product-card-atc-component')) {
  customElements.define('product-card-atc-component', ProductCardAtcComponent);
}

